/* eslint-disable */
export default {
  to: 'An',
  enterNameOrNumber: 'Name/Nr. eingeben',
} as const;

// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter name or number"@#@
